/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopOrderArticleRequestDto } from '../../models/shop-order-article-request-dto';
import { ShopOrderDto } from '../../models/shop-order-dto';

export interface ShopCreateOrder$Params {
  'x-trace-id'?: string;
      body: ShopOrderArticleRequestDto
}

export function shopCreateOrder(http: HttpClient, rootUrl: string, params: ShopCreateOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderDto>> {
  const rb = new RequestBuilder(rootUrl, shopCreateOrder.PATH, 'post');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopOrderDto>;
    })
  );
}

shopCreateOrder.PATH = '/api/shop/order';
